// See #1294 for the reasons why this is needed
export const PLUGINS_TO_IGNORE_IN_HASH_APP_STATE = ["anchor"];
